import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  CTA,
  CustomInput,
  CustomSelect,
  Inline,
  Modal,
  NoResult,
  Text,
} from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import {
  COURSE_CATEGORIES_GET,
  COURSE_LIST_GET,
} from '../../../../app/redux/actions/courselist';
import Pagination from '../../Pagination';
import SortBy from '../../SortBy';
import {
  CourseCard,
  CourseCardMobile,
  FiltersContainer,
  FixedContainer,
  Legend,
  Sorting,
} from './style';
import { timestampToDate } from '../../../../utils/common';
import { COURSE_TYPOLOGY_OPTIONS, getLabel } from '../../../../utils/labels';
import { flattenCategories } from '../../../../utils/categories';

export const ModalRelatedCoursesId = 'ModalRelatedCourses';

const ModalRelatedCourses = ({
  mediaIsPhone,
  isOpen,
  list,
  pager,
  getCategories,
  categories,
  addedCourses = [],
  setAddedCourses,
  getCourseList,
  modalClose,
}) => {
  const scrollableAreaRef = useRef(null);
  // filters
  const [selectedFilters, setSelectedFilters] = useState({});
  const [searchValue, setSearchValue] = useState();

  const [selectedCourses, setSelectedCourses] = useState(addedCourses);
  const [showFilters, setShowFilters] = useState(true);
  const [subjects, setSubjects] = useState([]);

  useEffect(() => {
    getCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSelectedCourses([...(addedCourses || [])]);
  }, [addedCourses]);

  useEffect(() => {
    setShowFilters(!mediaIsPhone);
  }, [mediaIsPhone]);

  useEffect(() => {
    handleGetCourses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  useEffect(() => {
    if (selectedFilters?.category) {
      const currentCategory = categories?.find(
        (c) => c?.id === selectedFilters?.category
      );
      const newSubjects = flattenCategories(currentCategory?.children, 0, true);
      setSubjects(newSubjects);
    } else setSubjects([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters?.category]);

  const onClickSearch = () => {
    setSelectedFilters({ ...selectedFilters, search_text: searchValue });
  };

  const handleOnChange = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value || value;
    setSelectedFilters(newFilters);
  };

  const handleGetCourses = (page) => {
    const parsedFilters = {
      ...selectedFilters,
      categories: selectedFilters?.subject || selectedFilters?.category,
      categoryType: selectedFilters?.subject
        ? 'single_categories'
        : 'parent_categories',
      page,
    };
    delete parsedFilters?.category;
    delete parsedFilters?.subject;
    getCourseList(parsedFilters);
  };

  const loadMore = (page) => handleGetCourses(page);
  const setItemsPerPage = (v) =>
    handleOnChange({ key: 'items_per_page', value: v });

  const handleOnClick = (course) => {
    const newCourses = [...selectedCourses];
    const courseId = selectedCourses?.findIndex((sc) => sc?.id === course?.id);
    if (courseId < 0) newCourses.push(course);
    else newCourses.splice(courseId, 1);
    setSelectedCourses(newCourses);
  };

  const isSelected = (course) =>
    selectedCourses?.findIndex((sc) => sc?.id === course?.id) >= 0;

  return (
    <Modal
      title="Inserisci percorsi formativi correlati"
      mbTitle={24}
      modalId={ModalRelatedCoursesId}
      scrollableAreaRef={scrollableAreaRef}
    >
      <FixedContainer>
        <Text type="h2" mb={24}>
          Percorsi formativi
        </Text>
        <FiltersContainer>
          <CustomInput
            size={mediaIsPhone ? 's' : 'm'}
            placeholder="Cosa vuoi cercare?..."
            isSearch
            value=""
            icon="search-sm"
            isClearable
            onChange={(v) => setSearchValue(v)}
            onClickIcon={onClickSearch}
            onKeyPress={(event) => {
              if (event.key === 'Enter') onClickSearch();
            }}
          />
          {mediaIsPhone && (
            <CTA
              type="secondary"
              btnText={showFilters ? 'Nascondi' : 'Filtri'}
              onClick={() => setShowFilters(!showFilters)}
            />
          )}
          {showFilters && (
            <>
              <CustomSelect
                size={mediaIsPhone ? 'full' : 's'}
                wrapperId="filter-typology"
                placeholder="Tipologia"
                options={COURSE_TYPOLOGY_OPTIONS}
                onChange={(value) => handleOnChange({ key: 'typology', value })}
                isClearable
              />
              <CustomSelect
                size={mediaIsPhone ? 'full' : 's'}
                placeholder="Area tematica"
                options={categories}
                isClearable
                onChange={(v) =>
                  setSelectedFilters({
                    ...selectedFilters,
                    category: v?.id,
                  })
                }
                selected={
                  categories?.find(
                    (c) => c?.id === selectedFilters?.category
                  ) ?? null
                }
              />
              <CustomSelect
                size={mediaIsPhone ? 'full' : 's'}
                placeholder="Materia"
                options={subjects}
                isClearable
                onChange={(v) =>
                  setSelectedFilters({
                    ...selectedFilters,
                    subject: v?.id,
                  })
                }
                selected={
                  subjects?.find((s) => s?.id === selectedFilters?.subject) ??
                  null
                }
              />
              {mediaIsPhone && (
                <SortBy
                  onChange={(v) =>
                    setSelectedFilters({
                      ...selectedFilters,
                      sort_by: v?.value,
                    })
                  }
                />
              )}
            </>
          )}
        </FiltersContainer>
        {mediaIsPhone ? (
          <Text type="b3" mb={24}>
            {pager?.total_items ?? 0} corsi disponibili
          </Text>
        ) : (
          <Sorting className="d-flex sb g-24">
            <Text type="b3">{pager?.total_items ?? 0} corsi disponibili</Text>
            <SortBy
              onChange={(v) =>
                setSelectedFilters({
                  ...selectedFilters,
                  sort_by: v?.value,
                })
              }
            />
          </Sorting>
        )}
      </FixedContainer>
      {!mediaIsPhone && (
        <Legend>
          <Text type="h3.5">Codice</Text>
          <Text type="h3.5">Titolo</Text>
          <Text type="h3.5">Area tematica</Text>
          <Text type="h3.5">Materia</Text>
          <Text type="h3.5">Data di pubblicazione</Text>
        </Legend>
      )}
      <ScrollableArea ref={scrollableAreaRef} preserveShadows>
        {list?.length > 0 ? (
          (list || []).map((item) => {
            if (!item?.id) return null;
            if (mediaIsPhone) {
              return (
                <CourseCardMobile
                  key={`item-${item?.id}`}
                  className={isSelected(item) ? 'active' : ''}
                >
                  <Text type="h5">Codice</Text>
                  <Text type="b4" className="code">
                    {item?.code}
                  </Text>
                  <Text type="h5">Tipologia</Text>
                  <Text type="b4">{item?.typology || '-'}</Text>
                  <Text type="h5">Titolo</Text>
                  <Text type="h3" className="title">
                    {item?.title || '-'}
                  </Text>
                  <Text type="h5">Area tematica</Text>
                  <Text type="b4" className="ellipsis">
                    {item?.category?.name || '-'}
                  </Text>
                  <Text type="h5">Materia</Text>
                  <Text type="b4" className="ellipsis">
                    <span />
                    {item?.subject?.name || '-'}
                  </Text>
                  <Text type="h5">Data di pubblicazione</Text>
                  <Text type="b4">{timestampToDate(item?.created)}</Text>
                  <div />
                  <CTA
                    bottomRight
                    type="tertiary"
                    btnText={isSelected(item) ? 'Annulla' : 'Seleziona'}
                    onClick={() => handleOnClick(item)}
                  />
                </CourseCardMobile>
              );
            }
            return (
              <CourseCard
                key={`item-${item?.id}`}
                className={isSelected(item) ? 'active' : ''}
              >
                <Text type="b4">{item?.code}</Text>
                <div className="ellipsis">
                  <Inline columnGap="8px">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="2"
                      height="18"
                      viewBox="0 0 2 18"
                      fill="none"
                    >
                      <path
                        d="M1 1L0.999999 17"
                        stroke="#22408B"
                        strokeLinecap="round"
                      />
                    </svg>
                    <Text type="b4">{getLabel(item?.typology)}</Text>
                  </Inline>
                  <Text type="h3" className="ellipsis">
                    {item?.title}
                  </Text>
                </div>
                <Text type="b4" className="ellipsis">
                  {item?.category?.name || '-'}
                </Text>
                <Text type="b4" className="ellipsis">
                  <span />
                  {item?.subject?.name || '-'}
                </Text>
                <Text type="b4">{timestampToDate(item?.created)}</Text>
                <CTA
                  type="tertiary"
                  btnText={isSelected(item) ? 'Annulla' : 'Seleziona'}
                  onClick={() => handleOnClick(item)}
                />
              </CourseCard>
            );
          })
        ) : (
          <NoResult />
        )}
        {pager?.number_of_pages > 1 && (
          <Pagination
            pt={48}
            pb={mediaIsPhone ? 16 : 36}
            pager={pager}
            callBack={loadMore}
            setItemsPerPage={setItemsPerPage}
          />
        )}
      </ScrollableArea>
      <Footer>
        <CTA
          type="secondary"
          btnText="annulla"
          fullsize={mediaIsPhone}
          onClick={modalClose}
        />
        <CTA
          type="primary"
          btnText="Inserisci"
          fullsize={mediaIsPhone}
          onClick={() => {
            setAddedCourses(selectedCourses);
            modalClose();
          }}
        />
      </Footer>
    </Modal>
  );
};

ModalRelatedCourses.propTypes = {
  addedCourses: PropTypes.array,
  setAddedCourses: PropTypes.func,
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  isOpen: PropTypes.bool,
  list: PropTypes.array.isRequired,
  pager: PropTypes.object.isRequired,
  categories: PropTypes.array.isRequired,
  // dispatch
  getCourseList: PropTypes.func.isRequired,
  getCategories: PropTypes.func.isRequired,
  modalClose: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { isOpen } = state.app.modal;
      const { list = [], pager = {} } = state.courselist.courses;
      const { categories } = state.courselist;
      return { isOpen, list, pager, categories };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      getCourseList: (filters) =>
        dispatch({
          type: COURSE_LIST_GET._REQUEST,
          filters,
        }),
      getCategories: (filters) =>
        dispatch({ type: COURSE_CATEGORIES_GET._REQUEST, filters }),
    })
  ),
  withMediaQueries
)(ModalRelatedCourses);
